// eslint-disable-next-line no-restricted-syntax
export enum SortOptions {
  ENTRIES_REMAINING = 'entriesRemaining',
  ENTRY_DEADLINE_DATE = 'startDate',
  ENTRY_FEE = 'entryFee',
  TOTAL_PRIZES = 'totalPrizes',
  START_DATE = 'startDate',
  ENTRANTS_COUNT = 'entrantsCount',
  CONTEST_NAME = 'contestName',
}

// eslint-disable-next-line no-restricted-syntax
export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
